exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/\nspan, a {\n  font-size: 14px;\n  word-break: break-word;\n}", ""]);

// exports
